import { useState } from 'react';

import { Hooks, TableInstance } from 'react-table';

import { TABLE_SIZE_THEMES } from '../consts';
import { TableSize, TableSizeTheme } from '../types';

const pluginName = 'useTableSizeTheme';

export type UseTableSizeThemeProps = {
  tableSizeTheme?: TableSizeTheme;
  setTableSizeTheme: (size: TableSize) => void;
  resetTableSizeTheme: () => void;
};

export type UseTableSizeThemeOptions = {
  defaultSize: TableSize;
};

const useInstance = <D extends Record<string, unknown>>(
  instance: TableInstance<D>
) => {
  const { defaultSize } = instance;

  const [size, setSize] = useState<TableSize>(defaultSize);
  const tableSizeTheme: TableSizeTheme = TABLE_SIZE_THEMES[size];

  const additions: UseTableSizeThemeProps = {
    tableSizeTheme,
    setTableSizeTheme: setSize,
    resetTableSizeTheme: () => setSize(defaultSize),
  };

  Object.assign(instance, additions);
};

export const useTableSizeTheme = <D extends Record<string, unknown>>(
  hooks: Hooks<D>
) => {
  hooks.useInstance.push(useInstance);
};

useTableSizeTheme.pluginName = pluginName;
